import React from 'react';

export const LoadingDots: React.FC = () => {
  return (
    <div className="flex gap-1">
      <span className="h-1.5 w-1.5 animate-[pulse_1.4s_ease-in-out_infinite] rounded-full bg-gray-400/60"></span>
      <span className="h-1.5 w-1.5 animate-[pulse_1.4s_ease-in-out_0.2s_infinite] rounded-full bg-gray-400/60"></span>
      <span className="h-1.5 w-1.5 animate-[pulse_1.4s_ease-in-out_0.4s_infinite] rounded-full bg-gray-400/60"></span>
    </div>
  );
};
